// Side-effect import, second in main.tsx: browser errors to Sentry before App's import
// tree evaluates, so an error while it loads is reported too (errorReporting.ts).
import { isNativeShell } from "../api";
import { installErrorReporting } from "./errorReporting";

installErrorReporting({ surface: "spa", platform: isNativeShell() ? "ios" : "web" });
